import { Grid, Paper } from "@mui/material";

import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

import "./index.css";
import ThreeComponent from "../../../components/ThreeColumnsComponent";
import TableLoans from "./TableLoans";
import {LOANS_TO_MY_CHARGE_HISTORY_ONE, LOANS_TO_MY_CHARGE_HISTORY_THREE, LOANS_TO_MY_CHARGE_HISTORY_TWO } from "../../../constants/signalRequestConsts";
import { searchLoansToApprove, setCompanyEmployeesLoading, setLoansToMyChargeEmployeesReset } from "../../../store/slices/userRequests";
import MySnackbar from "../../../components/MySnackbar";
import MySelectCompany from "../../../components/MySelectCompany";
import { getEmployeesInMyCharge } from "../../../api/s10OrganizationApi";


const LoansHistory = ({viewType}: {viewType: "All" | "InMyCharge" | "ToApprove"}) => {

    const dispatch = useDispatch<AppDispatch>();
    const {LOANS_TO_MY_CHARGE_HISTORY_ONE: {updateStatusResult: updateStatusResultOne}, LOANS_TO_MY_CHARGE_HISTORY_TWO: {updateStatusResult: updateStatusResultTwo}} = useSelector((state: RootState) => state.userRequests);
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const [rucSelected, setRucSelected] = useState<string>("all")

    const [pageOne, setPageOne] = useState<number>(1)
    const [pageTwo, setPageTwo] = useState<number>(1)
    const [pageThree, setPageThree] = useState<number>(1)

    const [pageSizeOne, setPageSizeOne] = useState<number>(25)
    const [pageSizeTwo, setPageSizeTwo] = useState<number>(25)
    const [pageSizeThree, setPageSizeThree] = useState<number>(25)

    const [statusOne, setStatusOne] = useState<0 | 1 | 2>(0)
    const [statusTwo, setStatusTwo] = useState<0 | 1 | 2>(1)
    const [statusThree, setStatusThree] = useState<0 | 1 | 2>(2)

    const [errorMsg, setErrorMsg] = useState<string>("");
    
  const [employeesCodes, setEmployeesCodes] = useState<string | null>(null)

    useEffect(() => {
        if (!companyselected || !connectionId) {
            return;
        }
        getInitialTablesData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, companyselected, connectionId]);
    
    useEffect(() => {
        if (!companyselected || !connectionId || employeesCodes === null) {
            return;
        }
        updateDataPageOne();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, pageSizeOne, pageOne, statusOne, employeesCodes, updateStatusResultOne, updateStatusResultTwo]);

    useEffect(() => {
        if (!companyselected || !connectionId || employeesCodes === null) {
            return;
        }
        updateDataPageTwo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, pageSizeTwo, pageTwo, statusTwo, employeesCodes, updateStatusResultOne, updateStatusResultTwo]);
    
    useEffect(() => {
        if (!companyselected || !connectionId || employeesCodes === null) {
            return;
        }
        updateDataPageThree();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, pageSizeThree, pageThree, statusThree, employeesCodes]);

    const updateDataPageOne = () => {
        console.log('employeesCodes', employeesCodes)
        if (employeesCodes === null) {
            return;
        }
        dispatch(setLoansToMyChargeEmployeesReset(LOANS_TO_MY_CHARGE_HISTORY_ONE));
        dispatch(searchLoansToApprove(
            LOANS_TO_MY_CHARGE_HISTORY_ONE, 
            employeesCodes,
            rucSelected === 'all' ? '' : rucSelected, 
            statusOne,
            pageSizeOne,
            pageOne,
        ));
    }

    const updateDataPageTwo = () => {
        console.log('employeesCodes', employeesCodes)
        if (employeesCodes === null) {
            return;
        }
        dispatch(setLoansToMyChargeEmployeesReset(LOANS_TO_MY_CHARGE_HISTORY_TWO));
        dispatch(searchLoansToApprove(
            LOANS_TO_MY_CHARGE_HISTORY_TWO, 
            employeesCodes,
            rucSelected === 'all' ? '' : rucSelected, 
            statusTwo,
            pageSizeTwo,
            pageTwo,
        ));
    }

    const updateDataPageThree = () => {
        console.log('employeesCodes', employeesCodes)
        if (employeesCodes === null) {
            return;
        }
        dispatch(setLoansToMyChargeEmployeesReset(LOANS_TO_MY_CHARGE_HISTORY_THREE));
        dispatch(searchLoansToApprove(
            LOANS_TO_MY_CHARGE_HISTORY_THREE, 
            employeesCodes,
            rucSelected === 'all' ? '' : rucSelected, 
            statusThree,
            pageSizeThree,
            pageThree,
        ));
    }
    
    const getInitialTablesData = async () => {
        setErrorMsg("");
        let _employeesCodes =  "";
        dispatch(setCompanyEmployeesLoading(true));
        setEmployeesCodes(null);
        const finalRuc = rucSelected === "all" ? "" : rucSelected;
        if (viewType === "InMyCharge") {
            const result = await getEmployeesInMyCharge(finalRuc);
            if (!result?.data?.length) {
                setErrorMsg("No posees personal asignado en el organigrama")
                return;
            }
            _employeesCodes = result?.data.join(",")
        }
        console.log('_employeesCodes', _employeesCodes)
        dispatch(setCompanyEmployeesLoading(false));
        setEmployeesCodes(_employeesCodes);
    }



    const ComponentOne = useCallback(() => (
        <TableLoans
            requestId={LOANS_TO_MY_CHARGE_HISTORY_ONE}
            allowApproveOptions={viewType === 'ToApprove'}
            onUpdate={() => {
                updateDataPageOne();
                updateDataPageTwo();
                updateDataPageThree();
            }}
            status={statusOne}
            setStatus={setStatusOne}
            page={pageOne}
            setPage={setPageOne}
            pageSize={pageSizeOne}
            setPageSize={setPageSizeOne}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);

    const ComponentTwo = useCallback(() => (
        <TableLoans
            requestId={LOANS_TO_MY_CHARGE_HISTORY_TWO}
            onUpdate={() => {
                updateDataPageOne();
                updateDataPageTwo();
                updateDataPageThree();
            }}
            allowApproveOptions={viewType === 'ToApprove'}
            status={statusTwo}
            setStatus={setStatusTwo}
            page={pageTwo}
            setPage={setPageTwo}
            pageSize={pageSizeTwo}
            setPageSize={setPageSizeTwo}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);
    const ComponentThree = useCallback(() => (
        <TableLoans
            requestId={LOANS_TO_MY_CHARGE_HISTORY_THREE}
            status={statusThree}
            setStatus={setStatusThree}
            page={pageThree}
            setPage={setPageThree}
            pageSize={pageSizeThree}
            setPageSize={setPageSizeThree}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);

    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
        <Paper
            elevation={3}
            style={{
                width: "100%", 
                borderRadius: "0.5rem",
                minHeight: "10rem",
                padding: "2rem 1.5rem"
            }}
        >
            <MySelectCompany 
                setRucSelected={setRucSelected} 
                rucSelected={rucSelected}
                includeAllCompaniesOption={true}
                allCompaniesOptionValue={'all'}
            />
            <ThreeComponent
                tabsTitle={["Por aprobar", "En Proceso", "Historico"]}
                useTabsNameAsTitle={true}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
        </Paper>
        <MySnackbar 
            open={errorMsg !== ""}
            autoHideDuration={6000}
            msg={errorMsg}
            severity="error"
            onClose={() => setErrorMsg("")} 
        />
    </Grid>)
}

export default LoansHistory;